import httpClient from "../../../client/httpClient";
import { getKeyPathFromUrl } from "./productPhotosService";

const sortByLastModifiedDesc = (a, b) => new Date(b.lastModified) - new Date(a.lastModified);

export const fetchProductPhotos = async ({ sellerId, filters = {}, pagination = {} }, signal) => {
    const { photoName = null } = filters;

    const { pageNo = 1, pageSize = 10 } = pagination;

    const endpoint = photoName
        ? `v1/api/image/file-server-get-by-name/${photoName}`
        : `v1/api/image/file-server-get/${sellerId}`;

    // Build params
    const params = {
        page: pageNo,
        size: pageSize,
        ...(photoName ? { sellerId } : {})
    };

    try {
        const res = await httpClient.get(endpoint, { signal, params });
        const items = res?.data?.items ?? [];

        return {
            ...res.data,
            content: items.sort(sortByLastModifiedDesc)
        };
    } catch (error) {
        console.error("Error fetching product photos:", error);
        throw error;
    }
};

export const deleteProductPhoto = async (photoUrl, signal) => {
    try {
        const key = getKeyPathFromUrl(photoUrl);
        const res = await httpClient.delete(`v1/api/image/file-server-delete?key=${key}`, {
            signal
        });
        return res.data;
    } catch (error) {
        console.error("Error deleting product photo:", error);
        throw error;
    }
};
